import { Link } from "react-router-dom";
import { usePageMeta } from "@/components/site/SEO";

export default function NotFound() {
  usePageMeta("Page not found", "The page you were looking for has wandered off the map.");
  return (
    <section className="container-x flex min-h-[70vh] flex-col items-start justify-center py-32" data-testid="not-found">
      <p className="eyebrow mb-5">404</p>
      <h1 className="max-w-xl text-4xl font-medium leading-tight tracking-tight sm:text-5xl">
        This path has wandered off the map
      </h1>
      <p className="mt-6 max-w-md text-lg leading-relaxed text-ink/75">
        The page you were looking for is not here. Let us walk you back to familiar ground.
      </p>
      <div className="mt-9 flex flex-wrap gap-x-8 gap-y-4">
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="bg-pine px-7 py-3.5 text-base font-medium text-canvas transition-colors hover:bg-pinedeep"
        >
          Back to Home
        </Link>
        <Link
          to="/journeys"
          data-testid="not-found-journeys-link"
          className="text-base font-medium text-pine underline decoration-pine/40 underline-offset-8 transition-colors hover:decoration-pine"
        >
          Explore Journeys
        </Link>
      </div>
    </section>
  );
}
